import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)

const LABEL_OVERRIDES: Record<string, string> = {
  under_review: 'Under Review',
  pending_verification: 'Pending Verification',
  full_time: 'Full-Time',
  part_time: 'Part-Time',
}

export function humanizeEnum(value: string): string {
  if (LABEL_OVERRIDES[value]) return LABEL_OVERRIDES[value]
  return value.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
}

export function formatDate(value: string | null | undefined): string {
  if (!value) return '—'
  return dayjs(value).format('D MMM YYYY')
}

export function formatDateTime(value: string | null | undefined): string {
  if (!value) return '—'
  return dayjs(value).format('D MMM YYYY, h:mm A')
}

export function formatRelativeTime(value: string | null | undefined): string {
  if (!value) return '—'
  return dayjs(value).fromNow()
}

export function formatCurrency(amount: number | null | undefined, currency = 'INR'): string {
  if (amount == null) return '—'
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  }).format(amount)
}

export function formatMonthsAsYears(months: number | null | undefined): string {
  if (months == null) return '—'
  const years = Math.round((months / 12) * 10) / 10
  return `${years} yr${years === 1 ? '' : 's'}`
}
